module.exports = __webpack_public_path__ + "static/media/FuturaStd-Book.f26c7d7d.ttf";